/**
* Image Gallery Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Image Gallery Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'image-gallery-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.image-gallery-slider:not(.blog-slider)' ).each( function( key, component ) {
        $( component ).find( '.slider' ).slick( {
          dots: false,
          arrows: false,
          infinite: true,
          centerMode: true,
          slidesToShow: 1,
          centerPadding: '17vw',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                centerPadding: '10vw',
              },
            },
          ],
        } );
      } );
      // set up the slider differently for the posts slider
      $( '.image-gallery-slider.blog-slider' ).each( function( key, component ) {
        $( component ).find( '.slider' ).slick( {
          dots: false,
          arrows: false,
          infinite: true,
          centerMode: true,
          slidesToShow: 1,
        } );
      } );


      $( '.image-gallery-slider' ).each( function( key, component ) {
        // prev slide
        $( component ).find( '.prev-slide' ).on( 'click', function() {
          $( this ).closest( '.slider' ).slick( 'slickPrev' );
        } );

        // next slide
        $( component ).find( '.next-slide' ).on( 'click', function() {
          $( this ).closest( '.slider' ).slick( 'slickNext' );
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'image-gallery-slider', COMPONENT );
} )( app );
